import React from 'react';

export const DetailCareTitleText = ({ t }) => {
  const activeTitle = t('care.title');
  const activeValue = t('care.value');

  return (
    <>
      <a target="_blank" className="care-link" href="//alliedfeather.com/info-room/down-care/how-to-clean-your-down"></a>
      <p className="spec-title">{activeTitle} <span>{activeValue}</span> </p>
      <p className="spec-value">{activeValue}</p>
    </>
  );
};
